<template>
    <div>
        <van-cell-group>
            <van-cell title="拣货工单" :value="form.pickNumber"/>
            <van-cell title="销售订单" :value="form.orderNo"/>
            <van-cell title="物料名称" :value="form.matName"/>
            <van-cell title="创建日期" :value="form.createTime|formatDate('yyyy/MM/dd')" />
            <van-cell title="拣货开始" :value="form.startTime|formatDate('yyyy/MM/dd HH:mm:ss')" />
            <template v-if="$route.query.activeName==2 || $route.query.activeName==3">
                <van-cell title="拣货工" :value="form.pickName"/>
                <van-cell title="拣货结束" :value="form.finishTime|formatDate('yyyy/MM/dd HH:mm:ss')" />
                <van-cell title="拣货耗时" :value="form.timeConsuming" />
            </template>
            <van-cell title="装货地" :value="form.loadingRoute" />
            <van-cell title="收货地" :value="form.unloadingRoute" />
            <van-cell title="车型" :value="form.vehicleModel+'米'" />
            <van-cell title="车牌号" :value="form.numberPlate" />
            <van-cell title="姓名" :value="form.driver" />
            <van-cell title="电话" :value="form.phoneNumber" />
            <van-cell title="承运公司" :value="form.shipperName" />
        </van-cell-group>
        <van-form @submit="submit">
            <van-field
                v-model="form.remark"
                :readonly="!($route.query && $route.query.activeName && $route.query.activeName == 4) || status == 4"
                rows="3"
                autosize
                label="备注"
                type="textarea"
                maxlength="100"
                placeholder="请输入备注"
                show-word-limit
            />
            <van-field name="uploader" label="上传水印照片" v-model="formUpload" required
                :rules="[{ required: true, message: '请上传至少一张水印照片' }]">
                <template #input>
                    <van-uploader v-model="form.fileList" max-count="5" multiple :before-read="beforeRead"  :readonly="!($route.query && $route.query.activeName && $route.query.activeName == 4) || status == 4"
                        :deletable="!(!($route.query && $route.query.activeName && $route.query.activeName == 4) || status == 4)"
                        :after-read="afterRead" @delete='deleteFile' />
                </template>
            </van-field>
            <div style="margin: 16px;"  v-if="status == 0 || status == '0'">
                <van-button round block type="info" native-type="submit">提 交</van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
import { CellGroup, Cell, Field, Form, Uploader, Button} from 'vant';
import Compressor from 'compressorjs';
import mixin_ossign from '../../../common/mixin_ossign';
import monitor from './mixins/monitor';
export default {
    mixins: [mixin_ossign,monitor],
    components: {
        [CellGroup.name]: CellGroup,
        [Cell.name]: Cell,
        [Field.name]: Field,
        [Form.name]: Form,
        [Uploader.name]: Uploader,
        [Button.name]: Button
    },
    data() {
        return {
            id: '',
            form: {
                remark: '',
                fileList: []
            },
            status: ''
        }
    },
    computed: {
        formUpload(){
            return this.form && this.form.fileList && this.form.fileList.length > 0 ? 'string':'';
        }
    },
    beforeRouteLeave(to, from, next) {
        //清除localStorage
        localStorage.removeItem('palletMonitorItem');
        if(to.name=='workbench-palletMonitor'){
            to.meta.keepAlive = true;
        }
        next();
    },
    created() {
        if(this.$route.query && this.$route.query.activeName && (this.$route.query.activeName == 2 )){
            this.status = 2;
            let palletMonitorItem = JSON.parse(window.localStorage.getItem('palletMonitorItem'));
            this.form = {
                ...palletMonitorItem
            };
            this.renderFileList();
        }else{
            this.renderFormData();
        }
    },
    mounted() {
        this.$jsbridge.call('setTitle', { title: '工单详情' }, null);
        this.$jsbridge.call('setBack',{backToWebview:true},null);
    },
    methods: {
        t1est() {
            this.$router.push({
                path: '/workbench-palletMonitor',
                query: { 
                    activeName:this.$route.query.activeName 
                }
            });
            // setTimeout(() => {
            //     this.$router.replace({
            //         query: { 
            //             activeName: this.$route.query.activeName 
            //         }
            //     });
            // }, 100);
        },
        async submit(){
            const _that = this;
            let now = new Date().getTime;
            if (now < this.form.timestamp * 1) {
                this.$dialog.alert({
                    message: '系统当前时间小于您的上次加载时间，不符合要求，请先检查您的系统时间是否正确！',
                }).then(() => {
                    this.$router.back(-1);
                });
                return;
            }
            let pictureUrlList = [];
            this.form.fileList.forEach((item) => {
                if(item.osskey){
                    pictureUrlList.push(item.osskey);
                }
            });
            let data = {
                pictureUrlList,
                remark: this.form.remark,
                pickNumber: this.form.pickNumber
            };
            let store = {
                ...this.form,
                pickNumber: this.form.pickNumber,
                saveTime: new Date()
            }
            if (this.form.fileList && this.form.fileList.length > 0 && pictureUrlList.length == 0) {
                await this.updateMonitorData(store);
                this.$toast('已暂存');
                this.$router.back(-1);
                return;
            }
            
            this.axios.post('/report/monitor/pickList/submit', data, {
                handleErrorsYourself: true
            }).then(async (json) => {
                if (json.statusCode == '0') {
                    this.$toast('保存成功');
                    setTimeout(() => {
                        _that.deleteMonitorData(_that.pickNumber).then(() => {
                            this.$router.replace({
                                path: '/workbench-palletMonitor',
                                query: { 
                                    activeName: this.$route.query.activeName || '4',
                                    refresh: Date.now()
                                }
                            });
                        });
                    }, 100);
                } else {
                    await this.updateMonitorData(store);
                    this.$toast('已暂存');
                    this.$router.back(-1);
                }
            }).catch(async () => {
                await this.updateMonitorData(store);
                this.$toast('已暂存');
                this.$router.back(-1);
            });
        },
        beforeRead(file) {
            // 检测是否为相机拍照
            const isCamera = file.size === 0 || (Array.isArray(file) && file[0].size === 0);
            
            // 对图片进行压缩处理
            if (!Array.isArray(file)) {
                file = [file];
            }
            
            // 预先设置状态
            if (isCamera) {
                this.$toast.loading({
                    message: '正在处理照片...',
                    forbidClick: true,
                });
            }
            
            const promises = file.map((item) => {
                const isJPG = item.type.indexOf('image') === 0;
                if (!isJPG) {
                    this.$toast('请上传图片');
                    return Promise.reject('请上传图片');
                }
                return new Promise((resolve, reject) => {
                    new Compressor(item, {
                        maxWidth: 2048,
                        success(result) {
                            const compressedFile = new File([result], result.name, {
                                type: result.type,
                            });
                            resolve(compressedFile);
                        },
                        error(err) {
                            reject(err);
                        },
                    });
                });
            });
            
            return Promise.all(promises)
                .then((processedFiles) => {
                    const filteredFiles = processedFiles.filter((file) => file !== false);
                    if (isCamera) {
                        this.$toast.clear();
                    }
                    return filteredFiles.length === promises.length ? filteredFiles : false;
                })
                .catch((error) => {
                    if (isCamera) {
                        this.$toast.clear();
                    }
                    return false;
                });
        },
        afterRead(files) {
            if (!Array.isArray(files)) {
                files = [files]; // 确保files是数组
            }
            
            // 立即为所有文件设置上传中状态
            files.forEach((file) => {
                // 确保立即设置loading状态
                file.status = 'uploading';
                file.message = '上传中...';
                
                // 强制UI更新
                this.$forceUpdate();
                
                console.log('开始上传文件:', file);
                
                // 确保文件有正确的类型信息
                if (!file.type && file.file) {
                    file.type = file.file.type;
                }
                
                this.uploadImg(file, {
                    firstDir: 'report',
                    secondDir: 'PICK_LIST',
                }).then((res) => {
                    console.log('上传成功:', res);
                    file.status = 'done';
                    file.message = '上传成功';
                    this.$forceUpdate(); // 强制更新UI
                }).catch((err) => {
                    console.log('上传失败，已暂存:', err);
                    this.$toast('已暂存');
                    file.status = 'done';
                    file.message = '上传成功';
                    this.$forceUpdate(); // 强制更新UI
                });
            });
        },
        deleteFile(file, detail) {
            this.form.fileList.splice(detail.index, 1);
        },
        renderFormData() {
            console.log('xx');
            
            if (this.$route.query && this.$route.query.activeName && this.$route.query.activeName == 1 && this.$route.query.upload == 0) {
                this.status = 0;
            } else if (this.$route.query && this.$route.query.activeName && this.$route.query.activeName == 1 && this.$route.query.upload == 1) {
                this.status = 1;
            }
            this.pickNumber = this.$route.query.pickNumber;
            if (this.pickNumber && this.$route.query.pickNumber !== undefined) {
                this.form.pickNumber = this.$route.query.pickNumber;
                this.getMonitorDataById(this.form.pickNumber).then((data) => {
                    console.log('data', data);
                    
                    this.form = Object.assign({}, this.form, data);
                    this.renderFileList();
                });
            }
        },
        renderFileList() {
            if (this.form.pictureUrls) {
                this.form.fileList = [];
                let fileList = JSON.parse(this.form.pictureUrls);
                fileList.forEach((item) => {
                    let file = {
                        url: item,
                        status: 'done',
                        message: '上传成功',
                        osskey: item
                    }
                    this.form.fileList.push(file);
                })
            }
        }
    },
    
}
</script>